import { ref } from "vue";

export const alturaDaJanela = ref(window.innerHeight);

const atualizar = () => {
  alturaDaJanela.value = window.innerHeight;
};

window.addEventListener("resize", atualizar);

export default alturaDaJanela;